/**
 * O'zbekcha katalog — MANBA (source of truth).
 * `ru.ts` va `en.ts` shu obyektning tipiga bo'ysunadi: kalit tushib qolsa
 * TypeScript kompilyatsiyada yiqiladi.
 *
 * Interfeys tili — TZ X4: uz / ru / en.
 */
export const uz = {
  common: {
    appName: 'MyGram Admin',
    cancel: 'Bekor qilish',
    confirm: 'Tasdiqlash',
    save: 'Saqlash',
    saving: 'Saqlanmoqda…',
    delete: "O'chirish",
    close: 'Yopish',
    retry: 'Qayta urinish',
    search: 'Qidiruv',
    loading: 'Yuklanmoqda…',
    all: 'Hammasi',
    none: "Yo'q",
    copy: 'Nusxalash',
    copied: 'Nusxalandi',
    back: 'Orqaga',
    actions: 'Amallar',
    reason: 'Sabab',
    optional: '(ixtiyoriy)',
    apply: "Qo'llash",
    clear: 'Tozalash',
    signOut: 'Chiqish',
    profile: 'Profil',
    theme: 'Mavzu',
    themeDark: "Qorong'i",
    themeLight: 'Yorug‘',
    language: 'Til',
    never: 'Hech qachon',
    unknown: "Noma'lum",
    yes: 'Ha',
    no: "Yo'q",
    planned: 'rejalashtirilgan',
    plannedHint: 'Bu funksiya hali ishlamaydi',
  },

  auth: {
    signInTitle: 'MyGram Admin',
    signInSubtitle: 'Boshqaruv paneliga kirish',
    username: 'Login',
    password: 'Parol',
    signIn: 'Kirish',
    signingIn: 'Kirilmoqda…',
    invalidCredentials: "Login yoki parol noto'g'ri",
    networkError: 'Serverga ulanib bo‘lmadi. Tarmoqni tekshiring.',
    twoFactorCode: '2FA kodi',
    twoFactorInvalid: '2FA kodi noto‘g‘ri',

    ssoTitle: 'Yagona kirish (SSO)',
    ssoDesc: "my.mygram.my orqali kirish. Provayder hali ulanmagan.",
    webauthnTitle: 'Apparat 2FA (WebAuthn)',
    webauthnDesc:
      "Xavfsizlik kaliti majburiy bo'ladi. Provayder tanlanmagan — hozircha login va parol ishlatiladi.",

    sessionExpiredTitle: 'Sessiya muddati tugadi',
    sessionExpiredDesc: 'Xavfsizlik uchun qayta kiring.',
    sessionExpiredAction: 'Qayta kirish',

    idleLockedTitle: 'Qulflangan',
    idleLockedDesc: "30 daqiqa faoliyat bo'lmadi. Davom etish uchun parolni kiriting.",
    unlock: 'Qulfni ochish',

    roleSelectTitle: 'Rolni tanlang',
    roleSelectDesc: 'Sizda bir nechta rol bor. Bu sessiya uchun bittasini tanlang.',

    deviceTitle: "Qurilmani ro'yxatdan o'tkazish",
    deviceDesc: "Yangi qurilma rahbar tasdig'ini talab qiladi.",
    deviceFingerprint: 'Qurilma barmoq izi',
    devicePending: "Tasdiq so'rovi yuborildi",
    deviceWaiting: "Rahbar tasdig'i kutilmoqda. Bu qurilma tasdiqlanmaguncha kirib bo'lmaydi.",

    breakGlassTitle: 'Favqulodda kirish (break-glass)',
    breakGlassDesc:
      "Barcha huquqlar 4 soatga ochiladi. Butun jamoaga darhol xabar boradi va har bir amal alohida auditga tushadi.",
    breakGlassReason: 'Sabab (majburiy)',
    breakGlassReasonHint: "Nima uchun favqulodda kirish kerak? Bu matn butun jamoaga yuboriladi.",
    breakGlassWarning: "Bu qaytarib bo'lmaydigan ta'sirli harakat. Faqat haqiqiy favqulodda holatda ishlating.",
    breakGlassActivate: 'Favqulodda kirishni faollashtirish',

    ipDeniedTitle: 'IP manzil ruxsat etilmagan',
    ipDeniedDesc: "Ofis tarmog'i yoki korporativ VPN'dan kiring.",
    ipCurrent: 'Sizning IP manzilingiz',

    welcomeTitle: 'Xush kelibsiz',
    welcomeDesc: "Ishni boshlashdan oldin bir necha qadam bor.",

    demoTitle: 'A1 — Autentifikatsiya ekranlari',
    demoDesc:
      "Barcha 8 ta A1 ekrani. Server oqimi hali yo'q — jonli holatga ulanmagan ekranlar bu yerda ko'riladi va tasdiqlanadi.",
    demoBackToList: '← A1 ekranlari ro‘yxatiga qaytish',
    demoLiveNote: 'jonli (kirish oqimida)',
    demoOrphanNote: "yozilgan, lekin server oqimi yo'q",
  },

  modules: {
    overviewDesc: (done: number, total: number) => `28 modul · ${done}/${total} ekran jonli`,
    moduleDesc: (done: number, total: number) =>
      `${done}/${total} ekran jonli · qolgani rejalashtirilgan (ko'pi endpoint kutadi)`,
    live: 'jonli',
    planned: 'rejalashtirilgan',
    plannedScreenDesc: 'Bu ekran hali qurilmagan. Struktura tayyor; jonli qilish uchun quyidagi kerak:',
    plannedNeeds: 'Kerak:',
    plannedGeneric: "server-endpoint yoki infratuzilma",
  },

  broadcast: {
    title: "E'lonlar",
    note: "Foydalanuvchilarga ommaviy e'lon tuzish va tarixi (yuborish — alohida tasdiqli qadam).",
    compose: "Yangi e'lon",
    titleField: 'Sarlavha',
    bodyField: 'Matn',
    audience: 'Auditoriya',
    all: 'Hammaga',
    active: 'Faollarga',
    staff: 'Xodimlarga',
    draft: 'Qoralama',
    queued: 'Navbatda',
    sent: 'Yuborilgan',
    failed: 'Xato',
    recipients: 'Qabul qiluvchi',
    created: 'Qoralama saqlandi',
    createFailed: "Saqlab bo'lmadi",
    draftNote: 'Qoralama sifatida saqlanadi — hech kimga yuborilmaydi.',
    saveDraft: 'Qoralama saqlash',
    card: 'Kampaniya kartasi',
    cancelled: 'Bekor qilingan',
    queue: "Navbatga qo'yish",
    cancel: 'Bekor qilish',
    test: 'Test yuborish',
    actionOk: 'Bajarildi',
    actionFailed: 'Amal bajarilmadi',
    schedule: 'Rejalashtirish',
    scheduledTitle: 'Rejalashtirilgan',
    pushHealth: 'Push holati',
    pushHealthNote: "Push-provayder holati: FCM, ro'yxatdan o'tgan tokenlar, taqsimot.",
    fcm: 'FCM',
    fcmYes: 'Sozlangan',
    fcmNo: 'Sozlanmagan',
    pushTokens: 'Push tokenlar',
    byProvider: "Provayder bo'yicha",
    statusBreakdown: "Holat bo'yicha",
    templates: 'Shablonlar',
    tplNew: 'Yangi shablon',
    tplName: 'Shablon nomi',
    tplSaved: 'Shablon saqlandi',
    tplDeleted: "Shablon o'chirildi",
    policy: 'Yuborish siyosati',
    policyNote: 'Tezlik cheklovi va anti-spam qoidalari.',
    throttle: 'Daqiqada limit',
    throttleHint: '0 = cheksiz',
    dailyCap: 'Kunlik cheklov',
    dailyCapHint: '0 = cheksiz',
    cooldown: 'Sovish (soat)',
    cooldownHint: "Bir foydalanuvchiga e'lonlar orasidagi min. soat",
    antispam: 'Anti-spam yoqilgan',
    settingsSaved: 'Sozlama saqlandi',
    banner: 'Xizmat banneri',
    bannerNote: "Ilovada ko'rsatiladigan texnik/e'lon banneri (admin qo'yadi).",
    bannerText: 'Banner matni',
    severity: 'Muhimlik',
    info: "Ma'lumot",
    warning: 'Ogohlantirish',
    critical: 'Kritik',
    bannerEnabled: 'Banner yoqilgan',
    preview: "Ko'rinishi",
  },

  nav: {
    legal: 'Huquqiy',
    verification: 'Verifikatsiya',
    support: 'Support',
    dashboard: 'Boshqaruv',
    modules: 'Modullar',
    groups: 'Guruhlar',
    finance: 'Moliya',
    bots: 'Botlar',
    moderation: 'Moderatsiya',
    users: 'Foydalanuvchilar',
    geo: 'Geografiya',
    staff: 'Xodimlar',
    security: 'Xavfsizlik',
    broadcast: "E'lonlar",
    /** A18.01 tab nomi — sahifa sarlavhasi bilan takrorlanmasin. */
    auditLog: 'Audit jurnali',
    settings: 'Sozlamalar',
    collapse: 'Yon panelni yig‘ish',
    expand: 'Yon panelni ochish',
  },

  table: {
    columns: 'Ustunlar',
    density: 'Zichlik',
    densityCompact: 'Zich',
    densityNormal: 'Oddiy',
    densityComfortable: 'Keng',
    filters: 'Filtrlar',
    addFilter: 'Filtr qo‘shish',
    clearFilters: 'Hammasini tozalash',
    savedViews: 'Saqlangan ko‘rinishlar',
    saveCurrentView: 'Joriy ko‘rinishni saqlash',
    manageViews: 'Ko‘rinishlarni boshqarish',
    defaultView: 'Standart ko‘rinish',
    export: 'Eksport',
    refresh: 'Yangilash',
    selected: (n: number) => `${n.toLocaleString()} ta tanlandi`,
    selectAllMatching: (n: number) => `Filtr bo‘yicha hammasi: ${n.toLocaleString()}`,
    clearSelection: 'Tanlovni bekor qilish',
    rowsPerPage: 'Sahifada',
    newRecords: (n: number) => `${n.toLocaleString()} ta yangi ↑`,
    showNew: 'Ko‘rsatish',
    rangeLabel: (from: number, to: number, total: number) =>
      `${from.toLocaleString()}–${to.toLocaleString()} / ${total.toLocaleString()}`,
    prevPage: 'Oldingi',
    nextPage: 'Keyingi',
    revealPii: 'Ochish',
    piiRevealed: 'Ochildi — bu amal auditga yozildi',
    shortcuts: 'Klaviatura yorliqlari',
  },

  filter: {
    contains: 'ichida bor',
    equals: 'teng',
    startsWith: 'bilan boshlanadi',
    gt: 'katta',
    lt: 'kichik',
    between: 'oraliqda',
    is: 'bu',
    isAny: 'quyidagilardan biri',
    today: 'Bugun',
    last7: '7 kun',
    last30: '30 kun',
    thisMonth: 'Bu oy',
    lastMonth: "O'tgan oy",
    custom: 'Maxsus',
    from: 'dan',
    to: 'gacha',
  },

  states: {
    emptyTitle: 'Hech narsa topilmadi',
    emptyDesc: 'Filtrlarni o‘zgartirib ko‘ring yoki qidiruvni tozalang.',
    errorTitle: 'Yuklab bo‘lmadi',
    errorDesc: 'So‘rov bajarilmadi.',
    permissionDeniedTitle: 'Ruxsat yo‘q',
    permissionDeniedDesc: (perm: string) => `Bu bo‘lim uchun «${perm}» huquqi kerak.`,
    requestAccess: 'Huquq so‘rash',
    notFoundTitle: 'Sahifa topilmadi',
  },

  danger: {
    impactTitle: "Ta'sir",
    impactCalculating: "Ta'sir hisoblanmoqda…",
    reversible: (window: string) => `${window} ichida tiklash mumkin`,
    irreversible: 'Qaytarib bo‘lmaydi',
    reasonLabel: 'Sabab',
    reasonRequired: 'Sabab (majburiy)',
    reasonPlaceholder: 'Nima uchun bu amal bajarilmoqda?',
    reasonTooShort: (min: number) => `Kamida ${min} belgi kiriting`,
    reasonPresetLabel: 'Tez sabablar',
    typeToConfirmLabel: (name: string) => `Tasdiqlash uchun «${name}» deb yozing`,
    typeToConfirmMismatch: 'Kiritilgan matn mos kelmadi',
    fourEyesTitle: 'Ikkinchi xodim tasdig‘i kerak',
    fourEyesDesc:
      'Bu amal darhol bajarilmaydi. So‘rov yaratiladi va boshqa xodim uni tasdiqlashi kerak.',
    fourEyesCreate: 'So‘rov yaratish',
    fourEyesPending: 'Tasdiq kutilmoqda',
    waitPeriodTitle: 'Kutish davri',
    waitPeriodDesc: (min: number) =>
      `Amal ${min} daqiqadan keyin bajariladi. Shu vaqt ichida istalgan xavfsizlik xodimi uni to‘xtata oladi.`,
    notifyTeam: 'Butun jamoaga xabar beriladi',
    undo: 'Bekor qilish',
    undoneToast: 'Amal bekor qilindi',
    level: (n: number) => `Daraja ${n}`,
    levelName: {
      1: 'Yengil',
      2: "O'rtacha",
      3: "Og'ir",
      4: 'Kritik',
      5: 'Favqulodda',
    } as Record<number, string>,
  },

  /** A2.01 — Dashboard. Matnlar ekranda qattiq yozilmaydi. */
  rt: {
    title: 'Real-time monitor',
    note: 'Jonli hisoblagichlar — har 5 soniyada yangilanadi.',
    active5m: 'Faol (5 daq)',
    msgMin: 'Xabar / daq',
    signupMin: 'Ro\'yxat / daq',
    msgHour: 'Xabar / soat',
    signupHour: 'Ro\'yxat / soat',
    series: 'Xabar oqimi (so\'nggi 15 daqiqa)',
    updated: 'Yangilandi',
    pause: 'To\'xtatish',
    resume: 'Davom',
  },

  userExtra: {
    ticketsTitle: 'Support tiketlari',
    noTickets: 'Tiket yo\'q',
    priority: 'Prioritet',
    reportsTitle: 'Shikoyatlar (undan va unga qarshi)',
    direction: 'Yo\'nalish',
    by: 'Undan',
    against: 'Unga',
    target: 'Nishon',
    resolved: 'Hal qilindi',
    dismissed: 'Rad etildi',
    openReport: 'Ochish',
    botsTitle: 'Egalik qilgan botlar',
    botUsername: 'Bot @username',
    botName: 'Bot nomi',
    revoked: 'Bekor qilingan',
    giftsTitle: 'Sovg\'a / Stars',
    giftsSent: 'Yuborilgan',
    giftsReceived: 'Olingan',
    giftsCount: 'Jami sovg\'a',
    relatedTitle: 'Bog\'liq akkauntlar',
    platform: 'Platforma',
    device: 'Qurilma',
    lastActive: 'Oxirgi faollik',
  },

  infra: {
    title: "Infratuzilma dashboard'i",
    note: 'Go-process runtime + PostgreSQL sog\'ligi — jonli, read-only.',
    runtime: 'Runtime (Go)',
    database: 'Ma\'lumotlar bazasi',
    uptime: 'Ishlash vaqti',
    goroutines: 'Goroutine',
    heap: 'Heap',
    heapAlloc: 'Heap ajratilgan',
    heapSys: 'Heap tizim',
    dbSize: 'DB hajmi',
    goVersion: 'Go versiyasi',
    numCpu: 'CPU yadro',
    gcCount: 'GC soni',
    pgVersion: 'PostgreSQL',
    dbName: 'DB nomi',
    migration: 'Migratsiya',
    activeConns: 'Faol ulanishlar',
    pool: 'Ulanish puli',
    idle: 'bo\'sh',
  },

  myTasks: {
    title: 'Mening vazifalarim',
    note: 'Sizga tayinlangan ish',
    myTickets: 'Mening tiketlarim',
    approvals: 'Tasdig\'imni kutmoqda',
    noTickets: 'Sizga tayinlangan ochiq tiket yo\'q',
    noApprovals: 'Tasdiq kutayotgan four-eyes yo\'q',
  },

  secDash: {
    title: "Xavfsizlik dashboard'i",
    note: "Audit, four-eyes va xodim holati — jonli.",
    fourEyesOpen: 'Ochiq four-eyes',
    staffActive: 'Faol xodim / jami',
    auditWindow: 'Audit hodisa (oyna)',
    topActions: 'Eng ko\'p amallar',
    recentAudit: "So'nggi audit",
    fullLog: "To'liq jurnal",
  },

  supDash: {
    title: "Support dashboard'i",
    note: "Tiketlar holat va prioritet bo'yicha — jonli.",
    total: 'Jami tiketlar (oyna)',
    openish: 'Ochiq / kutmoqda',
    categories: 'Kategoriyalar',
    byStatus: 'Holat bo\'yicha',
    byPriority: 'Prioritet bo\'yicha',
    recent: "So'nggi tiketlar",
  },

  modDash: {
    title: "Moderatsiya dashboard'i",
    note: "Barcha trust&safety navbatlarining kutayotgan yuklamasi — jonli.",
    openWorkload: 'Ochiq yuklama (jami kutmoqda)',
    reports: 'Shikoyatlar',
    tickets: 'Ochiq tiketlar',
    appeals: 'Apellyatsiyalar',
    verifications: 'Verifikatsiya',
    legal: "Huquqiy so'rovlar",
  },

  dash: {
    users: 'Foydalanuvchilar',
    usersHint: "O'chirilgan akkauntlar hisobga olinmaydi",
    dau: 'Faol (24 soat)',
    mau: 'Faol (30 kun)',
    messagesToday: 'Xabar (24 soat)',
    messages7d: 'Xabar (7 kun)',
    dialogs: 'Suhbatlar',
    mediaFiles: 'Media fayl',
    messagesPerDay: 'Kunlik xabarlar (7 kun)',
    activation: 'Faollashuv',
    activationHint: (sent: number, total: number) =>
      `${sent.toLocaleString()} / ${total.toLocaleString()} foydalanuvchi birinchi xabarini yubordi`,
    registrations: "Ro'yxatdan o'tish",
    regToday: 'Bugun',
    regD7: '7 kun',
    regD30: '30 kun',
    inconsistentTitle: "Server raqamlari bir-biriga zid",
    inconsistentDesc: (d7: number, total: number) =>
      `«7 kun» (${d7.toLocaleString()}) jami foydalanuvchidan (${total.toLocaleString()}) ko'p. ` +
      `Sabab: ro'yxatdan o'tish hisobi o'chirilgan akkauntlarni ham sanaydi, jami esa sanamaydi. ` +
      `Raqam server tuzatilmaguncha ishonchsiz.`,
    noData: "Bu davr uchun ma'lumot yo'q",
    valuesTable: 'Qiymatlar jadvali',
    tvTitle: 'Ekran rejimi',
    tvLive: 'Jonli',
    tvOffline: "Aloqa yo'q",
    tvUpdated: (time: string) => `Yangilandi ${time}`,
    tvExit: 'Chiqish',
    growthTitle: "O'sish dashboard'i",
    topCountries: "Davlat bo'yicha ro'yxatdan o'tish",
  },

  /** A18.06 — Four-eyes so'rovlari navbati. */
  groups: {
    group: 'Guruh',
    channel: 'Kanal',
    members: "A'zolar",
    forum: 'Forum',
    cardTitle: 'Chat kartasi',
    about: 'Tavsif',
    owner: 'Egasi',
    admin: 'Admin',
    member: "A'zo",
    customTitle: 'Maxsus unvon',
    joined: "Qo'shilgan",
    restricted: 'Cheklangan',
    membersTitle: "A'zolar ro'yxati",
    admins: 'Adminlar',
    adminsTitle: 'Adminlar va huquqlar',
    joinRequests: "Qo'shilish so'rovlari",
    requestedAt: "So'ralgan",
    bio: 'Bio',
    topics: 'Forum topiclari',
    general: 'General',
    pinned: 'Qadalgan',
    closed: 'Yopilgan',
    messages: 'Xabar tarixi',
    messageText: 'Matn',
    views: "Ko'rishlar",
    edited: 'Tahrirlangan',
    deleted: "O'chirilgan",
    adminLog: 'Admin jurnali',
    actor: 'Bajaruvchi',
    media: 'Media galereya',
    mediaNote: "Metadata + blurhash; bayt-preview media-proxy'ni kutadi (follow-up).",
    mime: 'MIME',
    size: 'Hajm',
    dimensions: "O'lcham",
    uploader: 'Yuklagan',
    stats: 'Statistika',
    new7d: "Yangi a'zo (7 kun)",
    messages7d: 'Xabar (7 kun)',
    messagesTotal: 'Jami xabar',
    topPosters: 'Top posterlar',
    boosts: 'Boost holati',
    boostLevel: 'Daraja',
    boostCount: 'Boosterlar',
    boostedAt: 'Boost vaqti',
    boostFree: "MyGram boostlari bepul (pul yo'q).",
    growth: "O'sish grafigi",
    botsTitle: 'Ulangan botlar',
    settingsTitle: 'Sozlamalar',
    reportsTitle: 'Shikoyatlar',
    signMessages: 'Imzolangan postlar',
    slowMode: 'Sekin rejim',
    joinByRequest: "So'rov bilan qo'shilish",
    contentProtected: 'Kontent himoyasi',
    historyVisible: "Tarix ko'rinadi",
    forumMode: 'Forum rejimi',
    topicLayout: "Topic ko'rinishi",
  },

  account: {
    secTitle: 'Xavfsizlik va kirish',
    secIdentity: 'Shaxs',
    secAccess: 'Ruxsatlar (RBAC)',
    sec2fa: 'Ikki bosqichli autentifikatsiya',
    sec2faNote: 'Sozlash backend-endpoint kutadi (rejalashtirilgan).',
    sec2faOn: 'Yoqilgan',
    sec2faOff: 'Yoqilmagan',
    sec2faEnable: '2FA yoqish',
    sec2faDisable: 'O‘chirish',
    sec2faScan: 'Bu maxfiy kalitni autentifikator ilovasiga (Google Authenticator va h.k.) qo‘shing, so‘ng tasdiqlash uchun 6 xonali kodni kiriting.',
    sec2faVerify: 'Tasdiqlab yoqish',
    sec2faCode: '6 xonali kod',
    sec2faSecret: 'Maxfiy kalit',
    secDevices: 'Qurilma va sessiyalar',
    secDevicesNote: 'Sessiya boshqaruvi backend-endpoint kutadi (rejalashtirilgan).',
    backendPending: 'Backend kutilmoqda',
    notifTitle: 'Bildirishnomalar',
    notifNote: 'Admin-panel ogohlantirishlari uchun lokal brauzer afzalliklari.',
    notifDesktop: 'Ish stoli bildirishnomalari',
    notifSound: 'Tovush',
    notifReports: 'Yangi shikoyatlar',
    notifTickets: 'Yangi tiketlar',
    notifFourEyes: "Ikki-juft-ko'z so'rovlari",
    profile: 'Mening profilim',
    interface: 'Interfeys sozlamalari',
    shortcuts: 'Klaviatura yorliqlari',
    username: 'Login',
    role: 'Rol',
    roles: 'Rollar',
    logout: 'Chiqish',
    language: 'Til',
    theme: 'Mavzu',
    dark: "Qorong'i",
    light: 'Yorug‘',
    scNext: 'Keyingi qator',
    scPrev: 'Oldingi qator',
    scSelect: 'Tanlash',
    scRange: 'Diapazon tanlash',
    scOpen: 'Ochish',
    scPanel: 'Yon panel',
    scSearch: 'Global qidiruv',
    scFilter: 'Filtrga fokus',
    scClose: 'Yopish / bekor',
    scHelp: 'Yorliqlar ro‘yxati',
    help: 'Yordam va qo‘llanma',
    helpIntro:
      'MyGram admin paneli — operatsion konsol: foydalanuvchilar, guruh/kanallar, moliya, geografiya, analitika va xavfsizlik. Har ekranning TZ ID’si sarlavha yonida ko‘rsatiladi.',
    helpModules: '614 ekranli modul-registri va progress',
    helpShortcuts: 'Klaviatura yorliqlari ro‘yxati',
  },

  loc: {
    glossaryTitle: 'Glossariy',
    glossaryNote: "Domen-atamalarining afzal tarjimasi — butun ilovada bir xil ishlating.",
    editorTitle: 'Tarjima muharriri',
    editorNote: "Tahrirlar lokal (brauzerda). Patch'ni yuklab olib commit qiling — serverda saqlash yozuv-endpoint kutadi (rejalashtirilgan).",
    downloadPatch: 'Patch yuklab olish',
    qcTitle: 'Sifat nazorati',
    issue: 'Muammo',
    issueEmpty: "Bo'sh",
    issuePlaceholder: "O'zgaruvchi nomuvofiq",
    issueUntranslated: 'Tarjimasiz',
    noIssues: 'Muammo topilmadi',
    exportTitle: 'Import / eksport',
    exportNote: "Klient i18n katalogini yuklab olinadigan formatga chiqaradi. Funksiya-qiymatlar (parametrli) chiqarib tashlanadi.",
    exportCount: (n: number) => `${n.toLocaleString()} ta kalit`,
    importNote: "Import (tarjimalarni qayta yozish) yozuv-endpoint kutadi — rejalashtirilgan (DEPS lane A).",
    packsTitle: 'Til paketlari',
    pluralsTitle: 'Pluralizatsiya qoidalari',
    pluralsNote: "CLDR ko'plik-kategoriyalari (til bo'yicha) — tarjimonlar uchun ma'lumotnoma.",
    title: 'Tillar ro‘yxati',
    note: 'Klient i18n kataloglari (uz/ru/en). Kalitlar TS-tip bilan majburlangan.',
    language: 'Til',
    keys: 'Kalitlar',
    untranslated: 'Tarjimasiz (~)',
    coverage: 'Qamrov',
    heuristic:
      '“Tarjimasiz” = qiymati inglizcha bilan aynan bir xil (evristika) — atoqli otlar (MIME, General) yolg‘on-musbat bo‘lishi mumkin.',
    keysTitle: 'Kalitlar ro‘yxati',
    missingTitle: 'Yetishmayotgan tarjimalar',
    statsTitle: 'Tarjima statistikasi',
    searchPh: 'Kalit yoki qiymat bo‘yicha qidirish…',
    value: 'qiymat',
    namespace: 'Nom-maydon',
    allTranslated: 'Barchasi tarjimalangan',
    showingCap: (n: number, total: number) => `${n.toLocaleString()} / ${total.toLocaleString()} ko‘rsatilmoqda`,
  },

  legal: {
    queue: 'Huquqiy so‘rovlar',
    queueNote: 'Kelgan qonuniy/GDPR so‘rovlarini qayd eting va bajarilishini kuzating.',
    log: 'So‘rov qo‘shish',
    created: 'So‘rov qayd etildi',
    createFailed: 'Saqlanmadi',
    kind: 'Tur',
    authority: 'So‘rovchi organ',
    reference: 'Reference / ish №',
    jurisdiction: 'Yurisdiksiya',
    affected: 'Tegishli user',
    details: 'Tafsilot',
    fulfilled: 'Bajarildi',
    rejected: 'Rad etildi',
    card: 'So‘rov kartasi',
    updateStatus: 'Holatni o‘zgartirish',
    resolutionPlaceholder: 'Bajarish izohi (ixtiyoriy)',
    statusChanged: 'Holat o‘zgartirildi',
    data: 'Ma‘lumot',
    preservation: 'Saqlash buyrug‘i',
    removal: 'Kontent o‘chirish',
    blocking: 'Bloklash',
    emergency: 'Favqulodda',
    rejectedTitle: 'Rad etilgan so‘rovlar',
    transparencyTitle: 'Shaffoflik hisoboti',
    total: 'Jami',
    byKind: 'Tur bo‘yicha',
  },

  verif: {
    queue: 'Verifikatsiya arizalari',
    queueNote: 'Userlar tasdiqlangan-belgi so‘raydi. Qabul qilinsa — rasmiy belgi beriladi.',
    kind: 'Tur',
    kindIdentity: 'Shaxs',
    kindOrg: 'Tashkilot',
    kindNotable: 'Mashhur',
    evidence: 'Dalil',
    approved: 'Tasdiqlandi',
    rejected: 'Rad etildi',
    registry: 'Tasdiqlanganlar reyestri',
    card: 'Ariza kartasi',
    approve: 'Tasdiqlash',
    reject: 'Rad etish',
    approveHint: 'Tasdiqlansa: foydalanuvchi rasmiy-belgi oladi (is_official).',
    approvedToast: 'Ariza tasdiqlandi, rasmiy-belgi berildi',
    rejectedToast: 'Ariza rad etildi',
    decideFailed: 'Qaror saqlanmadi',
    rejectedTitle: 'Rad etilgan arizalar',
    statsTitle: 'Verifikatsiya statistikasi',
    total: 'Jami',
    byKind: 'Tur bo‘yicha',
  },

  appeals: {
    queue: 'Apellyatsiyalar',
    queueNote: 'Userlar ban/strayk qaroriga e’tiroz bildiradi.',
    kind: 'Tur',
    kindBan: 'Ban',
    kindStrike: 'Strayk',
    granted: 'Qabul qilindi',
    rejected: 'Rad etildi',
    card: 'Apellyatsiya kartasi',
    decisionNote: 'Qaror izohi',
    decision: 'Qaror',
    notePlaceholder: 'Qaror izohi (ixtiyoriy)',
    reject: 'Rad etish',
    grant: 'Qabul qilish',
    grantHint: 'Qabul qilinsa: ban → bekor qilinadi, strayk → muddati tugaydi.',
    grantedToast: 'Apellyatsiya qabul qilindi, ijro bekor qilindi',
    rejectedToast: 'Apellyatsiya rad etildi',
    decideFailed: 'Qaror saqlanmadi',
  },

  strikes: {
    title: 'Strayk tarixi',
    queue: 'So‘nggi strayklar',
    queueNote: 'Progressiv-jazo. Strayklar report-qaroridan yoki qo‘lda beriladi.',
    severity: 'Daraja',
    issuedBy: 'Bergan',
    active: 'Amalda',
    expired: 'Muddati tugagan',
    activePoints: 'Aktiv ballar',
    issue: 'Strayk berish',
    issueBtn: 'Berish',
    issued: 'Strayk berildi',
    issueFailed: 'Strayk berilmadi',
    none: 'Strayklar yo‘q',
    statsTitle: 'Cheklov statistikasi',
    total: 'Jami',
  },

  support: {
    queue: 'Support tiketlari',
    queueNote: "Tiketlar userlardan keladi. Ochiq tiketlar tepada.",
    subject: 'Mavzu',
    open: 'Ochiq',
    pending: 'Kutilmoqda',
    closed: 'Yopiq',
    updated: 'Yangilangan',
    card: 'Tiket kartasi',
    staff: 'Xodim',
    user: 'Foydalanuvchi',
    replySent: 'Javob yuborildi',
    statusChanged: 'Holat o‘zgartirildi',
    actionFailed: 'Amal bajarilmadi',
    replyPlaceholder: 'Javob yozing…',
    send: 'Yuborish',
    slaTitle: 'SLA monitoringi',
    overdueTitle: 'Kechikkan tiketlar',
    age: 'Yosh',
    days: (n: number) => `${n} kun`,
    fresh: 'Yangi (<24s)',
    aging: 'Eskirmoqda',
    breached: 'Muddati o‘tgan',
  },

  mod: {
    queue: 'Moderatsiya navbati',
    queueNote: "Shikoyatlar userlardan keladi. Kategoriya/holat bo'yicha filtrlang.",
    category: 'Kategoriya',
    priorityTitle: 'Prioritetli navbat',
    target: 'Obyekt',
    reporter: 'Shikoyatchi',
    reason: 'Sabab',
    pending: 'Kutilmoqda',
    resolved: 'Hal qilindi',
    dismissed: 'Rad etildi',
    reportCard: 'Shikoyat kartasi',
    resolution: 'Qaror izohi',
    decision: 'Qaror',
    resolutionPlaceholder: 'Qanday chora ko‘rildi (ixtiyoriy)',
    dismiss: 'Rad etish (buzilish yo‘q)',
    resolve: 'Hal qilish (chora ko‘rildi)',
    resolvedToast: 'Shikoyat hal qilindi',
    dismissedToast: 'Shikoyat rad etildi',
    decideFailed: 'Qaror saqlanmadi',
    banUser: 'Bloklash + hal qilish',
    bannedToast: 'Foydalanuvchi bloklandi, shikoyat yopildi',
    groups: 'Guruhlash (obyekt bo‘yicha)',
    groupsNote: "Bir obyektga qancha shikoyat kelgani — eng ko‘p shikoyat qilinganlar tepada.",
    reportCount: 'Shikoyatlar',
    latest: 'Oxirgi',
    reporterReliability: 'Shikoyatchi ishonchliligi',
    reporterReliabilityNote: 'Dismiss-rate yuqori = ko‘p asossiz shikoyat (ishonchsiz manba).',
    dismissRate: 'Rad-ulushi',
    catCsam: 'CSAM',
    catViolence: 'Zo‘ravonlik',
    catFraud: 'Firibgarlik',
    catSpam: 'Spam',
    catCopyright: 'Mualliflik huquqi',
    catDoxxing: 'Doxxing',
    catOther: 'Boshqa',
  },

  flags: {
    title: 'Feature-flaglar',
    card: 'Flag kartasi',
    key: 'Kalit',
    value: 'Qiymat',
    on: 'Yoqilgan',
    off: "O'chirilgan",
    changelog: "Flaglar o'zgarishlar jurnali",
    type: 'Turi',
    remoteTitle: 'Remote config qiymatlari',
    toggleTitle: "Flaglarni yoqish / o'chirish",
    toggleFailed: "Flagni o'zgartirib bo'lmadi",
    killTitle: 'Kill-switch (favqulodda o\'chirish)',
    killNote: "Faol flaglarni darhol o'chirish. Har bir o'chirish audit'ga yoziladi.",
    killEmpty: "Faol flag yo'q — o'chiradigan narsa yo'q.",
    kill: "O'chirish",
    killed: "Flag o'chirildi",
    killConfirmTitle: "Flagni favqulodda o'chirish",
    killConfirmDesc: (key: string) => `«${key}» darhol BARCHA foydalanuvchilar uchun o'chadi. Tasdiqlash uchun kalitni yozing.`,
    rolloutTitle: 'Bosqichma-bosqich yoyish (%)',
    rolloutNote: "Har flag foydalanuvchilarning N% iga yoqiladi (barqaror bucketlash — foiz oshsa faqat kengayadi).",
    rolloutSaved: (pct: number) => `Yoyish ${pct}% ga o'rnatildi`,
    historyTitle: "Flag o'zgarish tarixi",
    historyEmpty: "Bu flag uchun tarix yo'q (hali o'zgartirilmagan).",
    pickFlag: 'Flagni tanlang',
    current: 'joriy',
    restore: 'Qaytarish',
    restored: 'Qiymat qaytarildi',
    restoreTitle: 'Oldingi qiymatni qaytarish',
    restoreDesc: (key: string, value: string) => `«${key}» flagi «${value}» qiymatiga qaytariladi.`,
    segTitle: 'Flag auditoriya-segmenti',
    segPlatforms: 'Platformalar',
    segCountries: 'Davlatlar',
    segCountrySearch: 'Davlat qidirish (kod yoki nom)…',
    segNoneNote: "Cheklov yo'q — flag hamma joyda (tanlangan yoqilganlarga) ko'rinadi.",
    segActiveNote: 'Flag FAQAT tanlangan davlat/platformalarda yoqilgan bo\'ladi.',
    segSaved: 'Segment saqlandi',
    segCleared: 'Segment tozalandi (cheklovsiz)',
    segClear: 'Cheklovni olib tashlash',
    depsTitle: "Flag bog'liqliklari",
    depsPrereqs: 'Oldindan-shart flaglari',
    depsNoneNote: "Shart yo'q — flag mustaqil.",
    depsActiveNote: (key: string) => `«${key}» FAQAT quyidagi flaglar yoqilганда yoqiladi.`,
    depsSaved: "Bog'liqliklar saqlandi",
    depsCleared: "Bog'liqliklar tozalandi",
    depsClear: 'Shartlarni tozalash',
    schemaTitle: 'Flag qiymat-sxemasi',
    schemaType: 'Tur',
    schemaValues: 'Ruxsat etilgan qiymatlar',
    schemaValuesHint: "Vergul bilan ajrating (masalan: light, dark, auto).",
    schemaNone: "Sxema yo'q",
    schemaValid: 'Mos',
    schemaInvalid: 'Mos emas',
    schemaSaved: 'Sxema saqlandi',
    schemaCleared: 'Sxema olib tashlandi',
    schemaClear: 'Sxemani olib tashlash',
  },

  exp: {
    title: 'A/B tajribalar',
    create: 'Yangi tajriba',
    empty: "Hali tajriba yo'q.",
    on: 'Faol',
    off: "O'chiq",
    name: 'Nom',
    nameHint: 'Faqat [a-z0-9_], 1–64 belgi. Yaratilgach o‘zgarmaydi.',
    nameInvalid: "Nom noto'g'ri ([a-z0-9_])",
    enabled: 'Faol (klientга variant tarqatiladi)',
    variants: 'Variantlar (kalit + og‘irlik)',
    addVariant: 'Variant qo‘shish',
    needTwo: 'Kamida 2 variant kerak',
    saved: 'Tajriba saqlandi',
    saveFailed: "Saqlab bo'lmadi",
    deleted: "Tajriba o'chirildi",
    deleteTitle: "Tajribani o'chirish",
    deleteDesc: (name: string) => `«${name}» tajribasi o'chiriladi. Foydalanuvchilar variant olishni to'xtatadi.`,
    distribution: (n: number) => `Taqsimot (${n.toLocaleString()} namunaviy foydalanuvchi — haqiqiy tayinlash)`,
  },

  auditSearch: {
    title: 'Audit qidiruvi',
    anyAction: 'Har qanday amal',
    since: 'Dan',
    until: 'Gacha',
    search: 'Qidirish',
    hint: 'Filtrlarni to‘ldirib «Qidirish»ni bosing.',
    results: (n: number) => `${n.toLocaleString()} ta yozuv`,
  },

  suspStaff: {
    tab: 'Shubhali',
    note: 'Xodimlar destruktiv-amal (ban/delete/block/…) hajmi bo‘yicha; statistik-outlier «shubhali».',
    flaggedCount: (n: number) => (n > 0 ? `${n} ta shubhali` : 'shubhali yo‘q'),
    days: (n: number) => `${n} kun`,
    destructive: 'Destruktiv',
    total: 'Jami',
    targets: 'Obyektlar',
    reasonHigh: 'Yuqori hajm',
    reasonOutlier: 'Anomaliya',
  },

  metrics: {
    activeUsers: 'DAU / WAU / MAU',
    wau: 'WAU (7 kun)',
    wauNote: "WAU (7-kunlik faol) hozir analytics-endpointда yo‘q — follow-up.",
    newUsers: 'Yangi foydalanuvchilar',
    botEcosystem: 'Bot ekotizimi statistikasi',
    botsTotal: 'Jami botlar',
    botsOfficial: 'Rasmiy botlar',
    botsActive: 'Faol botlar',
    botsRevoked: 'Bekor qilingan',
    botsMiniApp: 'Mini App bilan',
    botsBusiness: 'Business bilan',
    botsInline: 'Inline bilan',
    botsGateway: 'Gateway-ro‘yxatda',
    botApps: 'Mini App‘lar',
    botGames: 'O‘yinlar',
    botActiveUsers: 'Bot faol foydalanuvchilar',
    messageVolume: 'Xabarlar hajmi',
    funnel: 'Funnel tahlili',
    totalUsers: 'Jami foydalanuvchi',
    sentFirst: 'Birinchi xabar yubordi',
  },

  analytics: {
    byPlatform: 'Platforma bo‘yicha',
    byChatType: 'Chat turlari bo‘yicha',
    byVersion: 'Versiya bo‘yicha',
    byAppVersion: 'Ilova versiyasi bo‘yicha',
    byOsVersion: 'OS versiyasi bo‘yicha',
    byLanguage: 'Til bo‘yicha',
    pointsEconomy: 'Ball iqtisodiyoti',
    pointsNote: "Ichki Ball (pulsiz, faollik-asosli) tizimi bo‘yicha agregat.",
    pointsCirculating: 'Muomaladagi Ball',
    pointsEarned: 'Jami ishlangan',
    pointsSpent: 'Jami sarflangan',
    pointsHolders: 'Egalar',
    pointsSuspended: 'Muzlatilgan',
    pointsPurchases: 'Xaridlar',
    pointsEarnByReason: 'Ball manbalari',
    pointsSpendByItem: 'Nimaga sarflanadi',
    moderationKpi: 'Moderatsiya KPI',
    modPending: 'Kutilmoqda',
    modResolved: 'Hal qilingan',
    modDismissed: 'Rad etilgan',
    modTotal: 'Jami shikoyat',
    modCreated7d: '7 kun yangi',
    modResolved7d: '7 kun hal',
    modAvgResolution: 'O‘rtacha hal vaqti',
    modByCategory: 'Kategoriya bo‘yicha',
    modTrend: 'Yangi shikoyatlar',
    daysLabel: (d: number) => `${d} kun`,
    channelBoosts: 'Kanal boostlari',
    channelBoostsNote: 'Kanal qo‘llab-quvvatlash (boost) — Ball asosida, pulsiz.',
    cbTotal: 'Jami boost',
    cbChannels: 'Qo‘llab-quvvatlangan kanallar',
    cbBoosters: 'Boost berganlar',
    cb7d: '7 kun boost',
    cbTop: 'Top kanallar',
    cbTrend: 'Boost dinamikasi',
    topBots: 'Top botlar',
    activity: 'Faollik (soat bo‘yicha)',
    activityNote: "Oxirgi 30 kun — hafta-kun × soat bo‘yicha xabar faolligi.",
    weekdays: ['Du', 'Se', 'Ch', 'Pa', 'Ju', 'Sh', 'Ya'],
    sessionDuration: 'Sessiya davomiyligi',
    sessionNote: "Qurilma sessiyasi umri: yaratilganidan oxirgi faollik (yoki bekor qilingan vaqt)gача.",
    totalSessions: 'Jami sessiya',
    activeSessions: 'Faol sessiya',
    avgSession: "O‘rtacha",
    medianSession: 'Median',
    durationDist: 'Davomiylik taqsimoti',
    durLt1h: '<1 soat',
    dur1h1d: '1s–1 kun',
    dur1d7d: '1–7 kun',
    dur7d30d: '7–30 kun',
    durGt30d: '>30 kun',
    durUnits: { d: 'k', h: 's', m: 'd' },
    retention: 'Retention (qaytish)',
    retentionNote: "Rolling D1/D7/D30: ro'yxatdan N kun oldin o'tgan foydalanuvchilarning N+ kundan keyin ham faol ulushi.",
    churn: 'Churn (ketish)',
    churnNote: 'Rolling D1/D7/D30: kohortning qaytmagan ulushi (1 − retention).',
    byWindow: 'Oyna bo‘yicha',
    channelGrowth: 'Kanal o‘sishi',
    channelGrowthNote: 'Kanallar soni va ularga a‘zo qo‘shilishi (oxirgi 30 kun, kunlik qatorlar).',
    totalChannels: 'Jami kanal',
    totalChannelMembers: 'Jami a‘zo',
    newChannels7d: 'Yangi kanal (7 kun)',
    newJoins7d: 'Yangi a‘zo (7 kun)',
    newChannelsSeries: 'Yangi kanallar (kunlik)',
    memberJoinsSeries: 'A‘zo qo‘shilishi (kunlik)',
    supportKpi: 'Support KPI',
    supportKpiNote: 'Tiketlar holati, hal-qilish vaqti va kesimlar (support_tickets, sof-agregat).',
    ticketsTotal: 'Jami tiket',
    ticketsOpen: 'Ochiq',
    ticketsPending: 'Kutilmoqda',
    ticketsClosed: 'Yopilgan',
    ticketsNew7d: 'Yangi (7 kun)',
    ticketsClosed7d: 'Yopilgan (7 kun)',
    ticketAvgResolution: 'O‘rtacha hal-vaqti',
    ticketMedianResolution: 'Median hal-vaqti',
    ticketByCategory: 'Kategoriya bo‘yicha',
    ticketByPriority: 'Muhimlik bo‘yicha',
    newTicketsSeries: 'Yangi tiketlar (kunlik)',
    adRevenue: 'Reklama daromadi',
    adRevenueNote: 'Reklama kampaniyalari bo‘yicha sof-agregat: daromad (sarflangan), byudjet, ko‘rsatish/bosish, holat/joylashuv kesimi.',
    adCampaigns: 'Kampaniyalar',
    adActive: 'Faol',
    adImpressions: 'Ko‘rsatishlar',
    adClicks: 'Bosishlar',
    adRevenueTotal: 'Daromad (sarflangan)',
    adBudget: 'Byudjet',
    adCtr: 'CTR',
    adByStatus: 'Holat bo‘yicha',
    adByPlacement: 'Joylashuv bo‘yicha (daromad)',
    inviteLinks: 'Taklif havolalari',
    inviteLinksNote: 'Taklif havolalari bo‘yicha sof-agregat: havola/foydalanish soni, faol/bekor, chat-turi kesimi, 30-kunlik yangi-havola qatori.',
    linksTotal: 'Jami havola',
    linksActive: 'Faol',
    linksRevoked: 'Bekor qilingan',
    linkUses: 'Jami foydalanish',
    linksNew7d: 'Yangi (7 kun)',
    linkAvgUses: 'O‘rtacha foydalanish',
    linkUsesByType: 'Chat-turi bo‘yicha (foydalanish)',
    newLinksSeries: 'Yangi havolalar (kunlik)',
    revenueDash: 'Daromad dashboard‘i',
    revenueDashNote: 'Platforma daromadi birlashgan: reklama (sarflangan), bozor komissiyasi (yakunlangan savdo) va bot Stars. PII-siz.',
    revTotal: 'Jami daromad',
    revSourceAd: 'Reklama',
    revSourceMarket: 'Bozor komissiyasi',
    revSourceStar: 'Bot Stars',
    revMarketGmv: 'Bozor GMV',
    revMarketTrades: 'Savdolar',
    revStarCharges: 'Stars to‘lovi',
    revBySource: 'Manba bo‘yicha',
    revPerDay: 'Daromad (kunlik: bozor+Stars)',
    metricsDict: 'Metrikalar lug‘ati',
    metricsDictNote: 'Analitika metrikalarining yagona manbai: har metrika, uning manba-jadvali va hisoblash formulasi (texnik ta’rif).',
    mdMetric: 'Metrika',
    mdSource: 'Manba (jadval)',
    mdFormula: 'Formula',
    arpuTitle: 'ARPU / ARPPU',
    arpuNote: 'Bir foydalanuvchiga (ARPU) va bir to‘lovchiga (ARPPU) o‘rtacha daromad. Daromad = reklama+bozor-komissiya+Stars; to‘lovchi = Stars-payer ∪ bozor-xaridor. PII-siz.',
    arpuPayers: 'To‘lovchilar',
    arpuValue: 'ARPU',
    arppuValue: 'ARPPU',
    arpuPayingRatio: 'To‘lovchi ulushi',
    marketTitle: 'Bozor analitikasi',
    marketNote: "Bozor e'lonlari, savdolari, sotuvchilari, takliflari va sharhlari bo‘yicha sof-agregat. GMV = savdolar summasi. PII-siz.",
    marketDetailLink: 'Bozor analitikasi (batafsil) →',
    mktListings: "E'lonlar",
    mktActive: 'Faol',
    mktSold: 'Sotilgan',
    mktAuctions: 'Auksionlar',
    mktSellers: 'Sotuvchilar',
    mktVerified: 'Tasdiqlangan',
    mktTrades: 'Savdolar',
    mktGmv: 'GMV',
    mktBids: 'Takliflar',
    mktReviews: 'Sharhlar',
    mktAvgRating: "O‘rtacha reyting",
    mktByStatus: "Holat bo‘yicha",
    mktNewListings: "Yangi e'lonlar (kunlik)",
    liveTitle: 'Live/Efir analitikasi',
    liveNote: "Efirlar, sovg‘alar, tomoshabinlar, izohlar va battle'lar bo‘yicha sof-agregat. Sovg‘a-summasi = live_gifts summasi. PII-siz.",
    liveDetailLink: 'Live/Efir analitikasi →',
    liveStreams: 'Efirlar',
    liveLive: 'Jonli',
    liveHosts: 'Boshlovchilar',
    liveLikes: 'Layklar',
    liveGifts: 'Sovg‘alar',
    liveGiftAmount: 'Sovg‘a summasi',
    liveViewers: 'Tomoshabinlar',
    liveComments: 'Izohlar',
    liveBattles: "Battle'lar",
    liveAvgDuration: 'O‘rtacha davomiylik',
    liveByStatus: 'Holat bo‘yicha',
    liveGiftsSeries: 'Sovg‘alar (kunlik summa)',
    storiesTitle: 'Stories analitikasi',
    storiesNote: "Story'lar va ko‘rishlar bo‘yicha sof-agregat: story soni/faol, mualliflar, ko‘rishlar, tomoshabinlar, 30-kunlik qatorlar. PII-siz.",
    storiesDetailLink: 'Stories analitikasi →',
    storiesTotal: "Story'lar",
    storiesActive: 'Faol',
    storiesAuthors: 'Mualliflar',
    storyViews: 'Ko‘rishlar',
    storyViewers: 'Tomoshabinlar',
    storyAvgViews: 'O‘rtacha ko‘rish',
    storiesSeries: "Yangi story'lar (kunlik)",
    storyViewsSeries: 'Ko‘rishlar (kunlik)',
    walletTitle: 'Wallet/Token iqtisodiyoti',
    walletNote: "Take-hamyon (wallets) va foydalanuvchi valyutalari (currencies/token) bo‘yicha sof-agregat. Muomaladagi = hamyon balanslari summasi. Ball'dan alohida tizim. PII-siz.",
    walletDetailLink: 'Wallet/Token iqtisodiyoti →',
    walBalance: 'Muomaladagi (Take)',
    walWallets: 'Hamyonlar',
    walTxns: 'Tranzaksiyalar',
    walTransferVol: 'Transfer hajmi',
    walCurrencies: 'Valyutalar',
    walSupply: 'Umumiy emissiya',
    walHolders: 'Token egalari',
    walTokenTxns: 'Token tranzaksiya',
    walByKind: 'Tur bo‘yicha',
    walTxnsSeries: 'Tranzaksiyalar (kunlik)',
    pollsTitle: "So'rovnomalar analitikasi",
    pollsNote: "So'rovnomalar, viktorinalar va ovozlar bo‘yicha sof-agregat: so'rovnoma soni/ochiq, viktorina/anonim/ko‘p-tanlov, ovozlar, ishtirokchilar, 30-kunlik qatorlar. PII-siz.",
    pollsDetailLink: "So'rovnomalar analitikasi →",
    pollsTotal: "So'rovnomalar",
    pollsOpen: 'Ochiq',
    pollVotes: 'Ovozlar',
    pollVoters: 'Ovoz beruvchilar',
    pollQuizzes: 'Viktorinalar',
    pollAnon: 'Anonim',
    pollMulti: 'Ko‘p-tanlov',
    pollOptions: 'Variantlar',
    pollAvgVotes: 'O‘rtacha ovoz',
    pollsSeries: "Yangi so'rovnomalar (kunlik)",
    pollVotesSeries: 'Ovozlar (kunlik)',
    reactTitle: 'Reaksiyalar analitikasi',
    reactNote: "Xabar reaksiyalari bo‘yicha sof-agregat: reaksiya soni, noyob emoji, qo‘yuvchilar, reaksiyalangan xabarlar, TOP-emoji, 30-kunlik qator. PII-siz.",
    reactDetailLink: 'Reaksiyalar analitikasi →',
    reactTotal: 'Reaksiyalar',
    reactEmojis: 'Noyob emoji',
    reactReactors: 'Qo‘yuvchilar',
    reactMessages: 'Reaksiyalangan xabar',
    reactTopEmojis: 'TOP emoji',
    reactSeries: 'Reaksiyalar (kunlik)',
    mediaTitle: 'Media/xotira analitikasi',
    mediaNote: "Fayllar va variantlar bo‘yicha sof-agregat: fayl soni/tayyor, egalar, xotira (bayt), variantlar, tur-kesim, 30-kunlik qator. PII-siz.",
    mediaDetailLink: 'Media/xotira analitikasi →',
    mediaFiles: 'Fayllar',
    mediaReady: 'Tayyor',
    mediaOwners: 'Egalar',
    mediaVariants: 'Variantlar',
    mediaStorage: 'Xotira',
    mediaVariantStorage: 'Variant xotira',
    mediaByKind: 'Tur bo‘yicha',
    mediaSeries: 'Yangi fayllar (kunlik)',
    contactsTitle: "Kontaktlar o'sishi",
    contactsNote: "Import qilingan kontaktlar bo‘yicha sof-agregat: kontakt soni, egalar, ilovadagi mos-kelgan, mos-nisbat, 30-kunlik qator. PII-siz.",
    contactsDetailLink: "Kontaktlar o'sishi →",
    contactsTotal: 'Kontaktlar',
    contactsOwners: 'Egalar',
    contactsMatched: 'Ilovada mos',
    contactsMatchRate: 'Mos nisbati',
    contactsSeries: 'Yangi kontaktlar (kunlik)',
  },

  skeleton: {
    bannerTitle: 'Rejalashtirilgan ekran (skelet)',
    needs: 'Talab qilinadi',
    adapterReady: "UI mo‘ljal-layout + ma’lumot-adapteri tayyor — pipeline ulanganda jonli bo‘ladi.",
    needsEvents: 'Hodisa-telemetriya + ClickHouse (event-ETL)',
    eventDiscovery: 'Event kashfiyoti',
    eventTaxonomy: "Event lug‘ati (taksonomiya)",
    userPath: "Foydalanuvchi yo‘li (path)",
    funnelCompare: 'Voronka taqqoslash',
    segmentCompare: 'Segment taqqoslash',
    cohortBuilder: 'Kohorta konstruktori',
    forecasting: 'Prognozlash',
    serviceQuality: 'Xizmat sifati (SLO/SLI)',
    reportBuilder: 'Hisobot konstruktori',
    needsObservability: 'Observability pipeline (Prometheus/Grafana + SLO-nishonlar)',
    needsReportEngine: 'Hisobot-konstruktor dvigateli (query-builder + eksport)',
    alertsCenter: 'Ogohlantirishlar markazi',
    dashboardBuilder: 'Dashboard konstruktori',
    needsAlerting: 'Alerting infratuzilmasi (alert-qoidalari + kanallar)',
    needsDashboardEngine: 'Widget-builder dvigateli (drag-and-drop + saqlash)',
    needsPayments: 'Fiat-to‘lov provayderi + AML infra (MyGram pulsiz dizayn)',
    needsRevenue: 'Daromad-ETL + monetizatsiya ma‘lumoti',
  },

  sms: {
    title: 'SMS provayderlar',
    note: 'Infobip provayder holati, real balans va yuborilgan SMS statistikasi (davlat/status/oxirgi). OTP kodlari maskalangan.',
    balance: 'Balans',
    totalSent: 'Jami yuborilgan',
    mode: 'Rejim',
    notConfigured: 'Sozlanmagan',
    byCountry: 'Davlat bo‘yicha',
    byStatus: 'Status bo‘yicha',
    recent: 'Oxirgi xabarlar',
    colNumber: 'Raqam',
    colMessage: 'Xabar',
    colStatus: 'Status',
    colTime: 'Vaqt',
  },

  music: {
    title: 'Musiqa kutubxonasi',
    note: 'Qo‘shiqlar moderatsiyasi (tasdiqlash/rad etish), premium belgilash, o‘chirish.',
    stAll: 'Barchasi',
    stPending: 'Kutilmoqda',
    stApproved: 'Tasdiqlangan',
    stRejected: 'Rad etilgan',
    colTitle: 'Nomi',
    colArtist: 'Ijrochi',
    colGenre: 'Janr',
    colDuration: 'Davomiylik',
    colPlays: 'Tinglashlar',
    colStatus: 'Holat',
    approve: 'Tasdiqlash',
    reject: 'Rad etish',
    premium: 'Premium',
    makePremium: 'Premium qilish',
    unpremium: 'Premiumni olib tashlash',
    confirmDelete: 'Tasdiqlaysizmi?',
  },

  community: {
    title: 'Jamoalar',
    note: 'Foydalanuvchi-yaratgan kanal/guruh to‘plamlari (egasi + guruh soni).',
    colName: 'Nomi',
    colOwner: 'Egasi',
    colGroups: 'Guruhlar',
    colCreated: 'Yaratilgan',
  },

  users: {
    ban: 'Bloklash',
    unban: 'Blokdan chiqarish',
    banLog: 'Ban tarixi',
    fairnessTitle: 'Adolat hisoboti',
    fairnessNote: "Ban va blokdan chiqarish nisbati — moderatsiya adolatining ko'rsatkichi (GET /admin/audit).",
    unbanRatio: 'Blokdan chiqarish nisbati',
    activeRestrictions: 'Aktiv cheklovlar',
    bannedAt: 'Bloklangan',
    viewCard: 'Karta',
    cardTitle: 'Foydalanuvchi kartasi',
    userNumber: 'ID raqam',
    email: 'Email',
    birthday: "Tug'ilgan kun",
    bio: 'Bio',
    lastSeen: 'Oxirgi faollik',
    bannedReason: 'Ban sababi',
    sessions: 'Sessiyalar',
    sessionsTitle: 'Sessiyalar va qurilmalar',
    platform: 'Platforma',
    device: 'Qurilma',
    osVersion: 'OS',
    appVersion: 'Ilova',
    revoked: 'Bekor qilingan',
    banTitle: (name: string) => `${name} — bloklash`,
    banDesc: "Foydalanuvchi bloklanadi va barcha sessiyalari darhol uziladi. Sabab majburiy.",
    forceLogout: 'Majburiy chiqarish',
    forceLogoutTitle: (name: string) => `${name} — barcha sessiyalardan chiqarish`,
    forceLogoutDesc:
      "Foydalanuvchining BARCHA sessiyalari uziladi (bloklanmaydi — qayta kira oladi). Shubhali qurilma/token uchun. Sabab auditga yoziladi.",
    forceLogoutPending: 'Bu amal backend deploy qilingandan keyin ishlaydi (patch kutilmoqda).',
    actionDone: 'Bajarildi',
    actionFailed: 'Amal bajarilmadi',
    groups: 'Guruh/kanallar',
    wallet: 'Hamyon',
    ownedGroups: 'Egalik qilgan guruh/kanallar',
    contact: 'Aloqa ma’lumotlari',
  },

  system: {
    title: 'Tizim sozlamalari',
    desc: "App haqiqatan ishlatadigan platforma konfiguratsiyasi (app_settings)",
    save: 'Saqlash',
    saved: 'Sozlamalar saqlandi',
    saveError: "Saqlab bo'lmadi",
    loadError: "Sozlamalarni yuklab bo'lmadi",
    maintenance: 'Texnik ishlar rejimi',
    maintenanceDesc: "Foydalanuvchi so'rovlariga 503 qaytaradi; admin, kirish va ichki xizmatlar ishlaydi.",
    maintenanceWarn: "Ilova hozir foydalanuvchilar uchun O'CHIRILGAN.",
    liveSection: 'Jonli efir',
    streamerPct: "Strimer sovg'a ulushi (%)",
    maxCohosts: 'Maks. ко-host',
    confirmMaintTitle: 'Texnik ishlar rejimi yoqilsinmi?',
    confirmMaint: "Siz o'chirmaguningizcha barcha foydalanuvchi so'rovlari 503 qaytaradi. Adminlar kira oladi.",
    confirmMaintOk: 'Yoqish',
  },
  market: {
    title: 'Bozor',
    sellerApps: 'Sotuvchi arizalari',
    categories: 'Kategoriyalar',
    shop: "Do'kon",
    region: 'Hudud',
    activity: 'Faoliyat',
    status: 'Holat',
    pending: 'Kutilmoqda',
    approved: 'Tasdiqlangan',
    rejected: 'Rad etilgan',
    suspended: 'Bloklangan',
    none: "Yo'q",
    approve: 'Tasdiqlash',
    reject: 'Rad etish',
    verify: 'Ishonchli belgilash',
    unverify: 'Belgini olib tashlash',
    rejectReason: 'Rad sababi',
    rejectPrompt: 'Rad etish sababini kiriting',
    rating: 'Reyting',
    deals: 'Bitimlar',
    verified: 'Ishonchli',
    created: 'Sana',
    done: 'Bajarildi',
    failed: 'Amal bajarilmadi',
    newCategory: 'Yangi kategoriya',
    editCategory: 'Tahrirlash',
    addCategory: "Kategoriya qo'shish",
    catTitle: 'Nom',
    catIcon: 'Ikonka (nomi)',
    catPosition: 'Tartib',
    catEnabled: 'Faol',
    catListings: "E'lonlar",
    catDisable: 'Yashirish',
    save: 'Saqlash',
    cancel: 'Bekor',
  },

  points: {
    title: 'Ball',
    earnRules: 'Earn qoidalari',
    catalog: 'Katalog',
    suspicions: 'Gumondorlar',
    event: 'Hodisa',
    amount: 'Miqdor',
    dailyCap: 'Kunlik chek',
    enabled: 'Faol',
    unlimited: 'Cheksiz',
    edit: 'Tahrirlash',
    save: 'Saqlash',
    cancel: 'Bekor',
    done: 'Bajarildi',
    failed: 'Amal bajarilmadi',
    code: 'Kod',
    itemTitle: 'Nom',
    price: 'Narx',
    category: 'Turkum',
    catCosmetic: 'Kosmetik',
    catBoost: 'Boost',
    catGift: 'Hadya',
    purchases: 'Sotib olishlar',
    newItem: 'Yangi element',
    addItem: "Element qo'shish",
    editItem: 'Tahrirlash',
    disable: 'Yashirish',
    reason: 'Sabab',
    score: "Og'irlik",
    clear: 'Oqlash',
    sanction: 'Muzlatish',
    statusOpen: 'Ochiq',
    statusCleared: 'Oqlangan',
    statusSanctioned: 'Muzlatilgan',
    user: 'Foydalanuvchi',
  },

  stickers: {
    moderation: 'Stiker to\'plamlari',
    empty: 'Stiker to\'plamlari yo\'q',
    title: 'To\'plam',
    status: 'Holat',
    count: 'Stiker',
    installs: 'O\'rnatilgan',
    reason: 'Sabab',
    approve: 'Tasdiqlash',
    reject: 'Rad etish',
    rejectPrompt: 'Rad etish sababini kiriting. To\'plam do\'kondan yashiriladi.',
    active: 'Faol',
    rejected: 'Rad etilgan',
    pending: 'Kutilmoqda',
    done: 'Bajarildi',
    failed: 'Amal bajarilmadi',
    economyHint: 'Iqtisod',
  },

  finance: {
    amount: 'Miqdor',
    note: 'Izoh',
    peer: 'Qarshi tomon',
    idempotency: 'Idempotentlik kaliti',
    wallets: 'Hamyonlar',
    balance: 'Balans',
    updated: 'Yangilangan',
    dashboard: "Moliya dashboard'i",
    dashboardNote: "Server qaytargan oyna ustidan (top N hamyon + so‘nggi tranzaksiyalar).",
    topWalletsSum: "Top hamyonlar yig‘indisi",
    walletsShown: "Ko‘rsatilgan hamyonlar",
    recentTxns: "So‘nggi tranzaksiyalar",
  },

  bots: {
    official: 'Rasmiy',
    emptyTitle: 'Bot yo‘q',
    emptyDesc: 'Hali bot yaratilmagan. Bot-platforma bot qo‘shgach bu yerda ko‘rinadi.',
    card: 'Bot kartasi',
    gatewayNote:
      "Bot egasi, statistika, webhook va token tarixi bot-platforma gateway'iga ulangach ko‘rinadi (A5.03–A5.09).",
    statusLabel: 'Holat',
    active: 'Faol',
    disabled: "O‘chirilgan",
    descLabel: 'Tavsif',
    aboutLabel: 'Bot haqida',
    commandsLabel: 'Buyruqlar',
    noCommands: 'Buyruq yo‘q',
    superadminOnly: 'Botni tahrirlash faqat super-adminda.',
    edit: 'Tahrirlash',
    addCommand: 'Buyruq qo‘shish',
    cmdName: 'Buyruq',
    ownerTitle: 'Egasi',
    noOwner: 'Egasi biriktirilmagan',
    webhookTitle: 'Webhook',
    noWebhook: 'Webhook o‘rnatilmagan',
    whPending: 'Navbatda',
    whMaxConn: 'Maks. ulanish',
    whLastError: 'Oxirgi xato',
    appsTitle: 'Mini ilovalar',
    noApps: 'Mini ilova yo‘q',
    businessTitle: 'Business ulanishlar',
    noBusiness: 'Business ulanish yo‘q',
    affiliateTitle: 'Affiliate dastur',
    noAffiliate: 'Affiliate dastur yo‘q',
    commission: 'Komissiya',
    duration: 'Muddat (oy)',
    gamesTitle: 'O‘yinlar',
    noGames: 'O‘yin yo‘q',
    players: 'O‘yinchilar',
    reportsTitle: 'Shikoyatlar',
    noReports: 'Shikoyat yo‘q',
    block: 'Bloklash',
    blockTitle: 'Botni bloklash',
    blockDesc: 'Bot akkaunti bloklanadi (ban). Bu kuchli amal.',
    statsTitle: 'Statistika',
    statMsgs: 'Xabarlar',
    statUpdates: 'Update-lar',
    statToday: 'bugun',
    appSettingsTitle: 'Mini App temasi',
    noAppSettings: 'Tema sozlanmagan',
    themeBg: 'Fon rangi',
    themeHeader: 'Sarlavha rangi',
    previewMediaTitle: 'Skrinshot / preview',
    noPreviewMedia: 'Preview media yo‘q',
    tokenTitle: 'API kaliti',
    noToken: 'Token maʼlumoti yo‘q',
    tokenActive: 'Faol',
    tokenRevoked: 'Bekor qilingan',
    tokenIssued: 'Berilgan',
    tokenRotated: 'Yangilangan',
    tokenRevokedAt: 'Bekor qilingan',
    makeOfficial: 'Rasmiy qilish',
    unmakeOfficial: 'Rasmiylikni olib tashlash',
    enable: 'Faollashtirish',
    disable: "O‘chirish",
    officialTitle: 'Botni rasmiy qilish',
    officialDesc: 'Bot rasmiy-belgi (✓) oladi va rasmiy sifatida ko‘rsatiladi.',
    unofficialTitle: 'Rasmiylikni olib tashlash',
    unofficialDesc: 'Botdan rasmiy-belgi olib tashlanadi.',
    enableTitle: 'Botni faollashtirish',
    enableDesc: 'Bot qayta faollashadi va so‘rovlarni qabul qiladi.',
    disableTitle: 'Botni o‘chirish',
    disableDesc: 'Bot o‘chiriladi va so‘rovlarni qabul qilmaydi (qaytarish mumkin).',
    actionDone: 'Bajarildi',
    actionFailed: 'Amal bajarilmadi',
  },

  security: {
    staffActivity: 'Xodim faoliyati',
    actionCount: 'Amallar soni',
    auditWindowNote: "Oxirgi 200 audit yozuvi bo‘yicha agregat (butun tarix emas).",
  },

  invites: {
    title: 'Taklif havolalari',
    usage: 'Foydalanish',
    creator: 'Yaratuvchi',
    primary: 'Asosiy',
    expires: 'Muddati',
  },

  geo: {
    sanctionsTitle: "Sanksiya ro'yxatlari",
    sanctionsNote: "OFAC/EU keng-tarqalgan sanksiya ro'yxatidagi davlatlar reyestr bilan solishtiriladi. «Review» = sanksiyada, lekin bloklanmagan.",
    compliance: 'Muvofiqlik',
    compliant: 'Muvofiq',
    reviewNeeded: "Ko'rib chiqish",
    block: 'Bloklash',
    unblock: 'Ochish',
    blockTitle: (name: string) => `«${name}» davlatini bloklash`,
    unblockTitle: (name: string) => `«${name}» blokini ochish`,
    blockDesc: "Bu davlatdagi foydalanuvchilar kirishni yo‘qotadi. 4-daraja: ikkinchi admin tasdig‘i kerak.",
    unblockDesc: "Bu davlat qayta ochiladi. 4-daraja: ikkinchi admin tasdig‘i kerak.",
    impactUsers: "ro‘yxatdan o‘tgan foydalanuvchi",
    reverseWindow: 'istalgan vaqt',
    requestCreated: "Four-eyes so‘rovi yaratildi — A18.06 navbatida tasdiq kutilmoqda",
    requestFailed: "So‘rov yaratilmadi",
    changelog: "O‘zgarishlar jurnali",
    countryCard: 'Davlat kartasi',
    growth: "Davlat bo‘yicha o‘sish",
    dialPrefixes: 'Raqam prefikslari',
    dialPrefixesNote: "Dial-kod bo‘yicha guruhlangan; ulashilgan prefiks (+7 = RU/KZ) belgilangan.",
    shared: 'Ulashilgan',
  },

  fourEyes: {
    title: 'Four-eyes so‘rovlari',
    subtitle: 'Ikkinchi xodim tasdig‘ini kutayotgan 4–5 darajali amallar',
    tab: 'Four-eyes',
    requester: 'So‘rovchi',
    approver: 'Tasdiqlovchi',
    level: 'Daraja',
    expires: 'Muddati',
    executeAfter: 'Bajarish mumkin',
    requiredRole: 'Kerakli rol',
    impact: "Ta'sir (so‘rov paytida muzlatilgan)",
    approve: 'Tasdiqlash',
    reject: 'Rad etish',
    cancel: 'To‘xtatish',
    execute: 'Bajarish',
    actionDone: 'Bajarildi',
    actionFailed: 'Amal bajarilmadi',
    cancelPrompt: "To‘xtatish sababi (kamida 10 belgi):",
    reasonShort: 'Sabab kamida 10 belgi bo‘lishi kerak',
    myRequests: 'Mening so‘rovlarim',
    openOnly: 'Faqat ochiq',
    selfApprovalBlocked: 'O‘z so‘rovingizni tasdiqlay olmaysiz',
    executorIsRequester: 'Amalni faqat so‘rovchining o‘zi bajaradi',
    waitUntil: (t: string) => `Kutish davri ${t} da tugaydi`,
    noEndpointTitle: 'Navbat serverdan o‘qilmaydi',
    noEndpointDesc:
      "Sxema tayyor va bazada sinovdan o'tgan (migratsiya 000076), lekin uni o'qiydigan HTTP metodi hali yozilmagan. Navbat soxta ma'lumot bilan to'ldirilmaydi.",
  },

  staff: {
    title: 'Xodimlar',
    subtitle: 'Rollar, huquqlar va jamoalar',
    member: 'Xodim',
    role: 'Rol',
    roles: 'Rollar',
    team: 'Jamoa',
    status: 'Holat',
    lastActive: 'Oxirgi faollik',
    createdAt: 'Qo‘shilgan',
    addMember: 'Xodim qo‘shish',
    permissionMatrix: 'Huquqlar matritsasi',
    rolesNote: "Rollar klient katalogidan (server rol-katalogi kelgach almashadi). Rol yaratish/tahrir server endpointini kutadi.",
    allPerms: 'barcha (*)',
    jitAccess: 'Vaqtinchalik huquqlar (JIT)',
    jitRemaining: (t: string) => `Vaqtinchalik huquq — ${t} qoldi`,
    offboard: 'Huquqlarni olib tashlash',
    suspend: 'To‘xtatib turish',
    emptyTitle: 'Xodimlar ro‘yxati bo‘sh',
    emptyDesc: 'Birinchi xodimni qo‘shing yoki mavjudini import qiling.',
    superAdminWarning: (n: number) =>
      `${n} ta super-admin bor. TZ bo‘yicha 2 tadan ko‘p bo‘lmasligi kerak.`,
    inactive: 'Nofaol',
    permCount: 'Huquqlar',
    lastLogin: 'Oxirgi kirish',
    roleSaved: 'Rol yangilandi',
    roleFailed: 'Rolni o‘zgartirib bo‘lmadi',
  },

  /** Jadval ustun sarlavhalari — ekranlarda qattiq yozilmaydi. */
  col: {
    id: 'ID',
    name: 'Ism',
    username: '@username',
    phone: 'Telefon',
    status: 'Holat',
    registered: "Ro'yxatdan o'tgan",
    country: 'Davlat',
    code: 'Kod',
    nationality: 'Millat',
    dialCode: 'Dial kod',
    registrations: "Ro'yxatdan o'tganlar",
    time: 'Vaqt',
    staff: 'Xodim',
    action: 'Amal',
    target: 'Obyekt',
    detail: 'Tafsilot',
    type: 'Tur',
    title: 'Nomi',
    ip: 'IP manzil',
  },

  status: {
    active: 'Faol',
    pending: 'Kutilmoqda',
    banned: 'Bloklangan',
    blocked: 'Bloklangan',
    deleted: 'O‘chirilgan',
    review: 'Ko‘rib chiqilmoqda',
    suspended: 'To‘xtatilgan',
    open: 'Ochiq',
    approved: 'Tasdiqlangan',
    rejected: 'Rad etilgan',
    expired: 'Muddati tugagan',
    executed: 'Bajarilgan',
    cancelled: 'To‘xtatilgan',
  },

  time: {
    justNow: 'hozir',
    secondsAgo: (n: number) => `${n} soniya oldin`,
    minutesAgo: (n: number) => `${n} daqiqa oldin`,
    hoursAgo: (n: number) => `${n} soat oldin`,
    daysAgo: (n: number) => `${n} kun oldin`,
    monthsAgo: (n: number) => `${n} oy oldin`,
    yearsAgo: (n: number) => `${n} yil oldin`,
  },

  env: {
    staging: 'STAGING muhiti',
    dev: 'DEV muhiti',
  },

  shortcuts: {
    title: 'Klaviatura yorliqlari',
    navigation: 'Navigatsiya',
    nextRow: 'Keyingi qator',
    prevRow: 'Oldingi qator',
    select: 'Tanlash',
    selectRange: 'Diapazon tanlash',
    open: 'Ochish',
    detailPanel: 'Yon panel',
    globalSearch: 'Global qidiruv',
    focusFilter: 'Filtrga fokus',
    primaryAction: 'Asosiy amalni bajarish',
    escape: 'Yopish / bekor qilish',
    toggleSidebar: 'Yon panelni almashtirish',
    goHome: 'Bosh sahifa',
    showShortcuts: 'Shu ro‘yxat',
  },
}

// `as const` ATAYLAB yo'q: bo'lsa har bir satr literal tipga aylanadi va
// `ru: Catalog` boshqa matn yozganda kompilyatsiya yiqiladi.
export type Catalog = typeof uz
